import { jsx as _jsx } from "react/jsx-runtime";
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
const AskSourceSuggestion = Dynamic(async () => {
    const { SourceSuggestion } = await import('#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/SourceSuggestion.js');
    return { default: SourceSuggestion };
});
export function renderLazyAskSourceSuggestion({ source, connected, onClick, iconOnly, }) {
    return (_jsx(AskSourceSuggestion, { source: source, connected: connected, onClick: onClick, iconOnly: iconOnly }));
}
//# sourceMappingURL=renderLazyAskSourceSuggestion.js.map